import { useState, useEffect } from "react"
import { LEGACY_DOCS_PARAM } from "~/docs-data/legacy-unacast-docs"

const STORAGE_KEY = "pine59-welcome-seen"

// Stop showing the announcement to anyone arriving after this date — by then
// Pine59 is no longer news and "new company" would only confuse new users.
// Extended past the Insights modal's original date because the
// unacast.com → console.pine59.com docs redirect went live 2026-09-01, so
// visitors keep landing here from the old brand for a while longer.
const EXPIRES = new Date("2026-12-01")

/**
 * One-time "Introducing Pine59" announcement for existing users landing in
 * the console after the rebrand. Seen-state is per-browser (localStorage),
 * same trade-off as the other console preferences.
 */
export function usePine59Welcome() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (new Date() > EXPIRES) return
    try {
      // A docs.unacast.com arrival gets the docs dialog instead
      // (LegacyDocsDialog, CAT-1204), which carries the same "new company"
      // message. Count it as seen so the two never stack.
      if (new URLSearchParams(window.location.search).has(LEGACY_DOCS_PARAM)) {
        localStorage.setItem(STORAGE_KEY, new Date().toISOString())
        return
      }
      if (!localStorage.getItem(STORAGE_KEY)) {
        setOpen(true)
      }
    } catch {}
  }, [])

  const dismiss = () => {
    setOpen(false)
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString())
    } catch {}
  }

  return { open, dismiss }
}
